import { SUITE } from "@/config/site";

const FOOTER_LINKS = [
  { label: "Pricing", href: "/pricing" },
  { label: "Compliance Service", href: "/services#compliance" },
  { label: "Consulting", href: "/services#consulting" },
  { label: "Privacy", href: "/privacy" },
  { label: "Terms", href: "/terms" },
  { label: "Contact", href: "/contact" },
  { label: "Field Services", href: "/field-services" },
  { label: "Sign in", href: "https://wsafeai.com/login" },
];

export default function Footer() {
  return (
    <footer className="bg-navydeep">
      <div className="mx-auto max-w-[1160px] px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 mb-12" data-testid="footer-product-strip">
          {SUITE.map((p) => (
            <a
              key={p.name}
              href={`https://${p.domain}`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`footer-product-${p.name.toLowerCase().replace(/\s/g, "-")}`}
              className="group"
            >
              <p className="flex items-center gap-2 text-sm font-bold text-white group-hover:text-safety transition-colors mb-1.5">
                <img src={p.icon} alt="" className="w-5 h-5" loading="lazy" />
                {p.name}
              </p>
              <p className="text-xs text-white/50 leading-snug">{p.desc}</p>
            </a>
          ))}
        </div>
        <div className="flex flex-wrap gap-x-7 gap-y-3 py-6 border-y border-white/10 mb-8">
          {FOOTER_LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/50 hover:text-safety transition-colors"
            >
              {l.label}
            </a>
          ))}
          <a
            href="mailto:info@wsafeai.com"
            data-testid="footer-email"
            className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/50 hover:text-safety transition-colors"
          >
            info@wsafeai.com
          </a>
        </div>
        <p className="text-xs font-semibold text-white/70 mb-2" data-testid="footer-brand-line">
          WSafe AI by WorkSafeAgent
        </p>
        <p className="text-[11px] text-white/40" data-testid="footer-legal-line">
          WorkSafeAgent LLC · Abilene, Texas · patent pending
        </p>
        <p className="text-[11px] text-white/30 mt-2">© 2026 WorkSafeAgent LLC</p>
      </div>
    </footer>
  );
}
